import AxiosInstance from "../instance";
import {emptyFn, returnValidResponse} from "../utils";

const getLanguageCodes = async () => {
    const response = await AxiosInstance.getInstance().get("/translate/language-codes").catch(emptyFn);
    return returnValidResponse(response);
};

const getTranslationResult = async (text: string, srcLang: string, destLang: string) => {
    const response = await AxiosInstance.getInstance().post("/translate", {
        text,
        source_lang: srcLang,
        destination_lang: destLang
    });

    return response;
};

const getTranslationTokensCount = async (text: string) => {
    const response = await AxiosInstance.getInstance().post("/translate/tokens", {
        text
    }).catch(emptyFn);

    return returnValidResponse(response);
};

export {getTranslationTokensCount, getTranslationResult, getLanguageCodes}


// WEBPACK FOOTER //
// ./src/api/models/Translation.ts